// Production build config — same merge pattern as config.js (which is the dev
// flavor; see its comments for why authConfig must be baked at build time).
// CI (.github/workflows/stac-browser.yml) swaps this file in as config.js
// before building, then syncs dist/ to the efa-stac-browser S3 bucket.
//
// The browser app is served from stac.firesat.com (CloudFront) and talks
// cross-origin to the STAC API at api.firesat.com — that origin must appear in
// the geoapi's STAC_CORS_ORIGINS, and the prod Keycloak realm needs a public
// `stac-browser` client with stac.firesat.com as redirect URI + web origin.
// See aws-infra/docs/stac-browser-deploy.md.
const base = require("./config.default.js");

module.exports = Object.assign({}, base, {
  catalogUrl: "https://api.firesat.com/stac",
  catalogTitle: "FireSat STAC",
  catalogImage: "/branding/firesat-lockup-horizontal.svg",
  historyMode: "history",

  // Domains the Keycloak bearer token may be attached to: ONLY the STAC API.
  // Asset hosts (S3/CDN thumbnails, COGs) must NOT be listed here, or the
  // token leaks to them in request headers.
  allowedDomains: ["api.firesat.com"],

  // Don't render band COGs on the map client-side (upstream default is on).
  // The assets' primary href is the https /download URL, so ol-stac treats them
  // as fetchable COGs and hands them to geotiff.js, which fetches without a
  // bearer token — every attempt 401s. Even authenticated it would mean
  // decoding dozens of 15 MB COGs in the browser. The `thumbnail` asset is the
  // preview; "Show on map" still works per asset on demand.
  displayOverview: false,

  authConfig: {
    type: "openIdConnect",
    openIdConnectUrl:
      "https://auth.firesat.com/realms/efa/.well-known/openid-configuration",
    oidcConfig: {
      client_id: "stac-browser",
    },
  },
});
